// extracted by mini-css-extract-plugin
export default {"clearButton":"ClearButton-module__clearButton__wvAWiEp"};